// extracted by mini-css-extract-plugin
export default {"title":"AccountsPayableDetails_title__-z+ME","pay":"AccountsPayableDetails_pay__j790E"};